<template>
  <div>
    <b-row>
      <b-col cols="12">
        <vs-card>
          <b-row align-h="start">
            <b-col cols="12" md="auto">
              <vs-chip
                style="font-size: 25px"
                v-b-tooltip.hover.bottom="'Siparişlerdeki toplam barkod adedi'"
                >{{ filteredBarcode }}
              </vs-chip>
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><b-form-input
                v-model="barcode"
                @keyup.enter="filterOrderList()"
                placeholder="Barkod Giriniz"
                id="barkodM"
              />
            </b-col>
            <b-col cols="12" md="auto">
              <vs-button
                @click="urunListGtr()"
                type="gradient"
                color="danger"
                style="border-radius: 5px"
                >Ürün Listesi</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto">
              <vs-button
                @click="faturaCikti()"
                type="gradient"
                color="primary"
                style="border-radius: 5px"
                >Fatura Çıktısı</vs-button
              >
            </b-col>
          </b-row>
        </vs-card>
        <vs-card>
          <b-row style="margin-left: 1px; margin-right: 1px">
            <b-col
              style="border: solid 0.1px; margin-bottom: 10px"
              cols="2"
              @click="tr.status == 1 ? getOrderDetails(tr.orderNumber) : ''"
              :key="indextr"
              v-for="(tr, indextr) in urunList"
            >
              <b-row>
                <b-col cols="10">
                  <h4>{{ tr.shelf }} - {{ tr.orderNumber }}</h4>
                </b-col>
                <b-col style="padding: 0px !important">
                  <vs-chip
                    :color="tr.status == 1 ? 'success' : 'warning'"
                    v-b-tooltip.hover.bottom="'Siparişin toplam adedi'"
                    >{{ tr.quantity }}
                  </vs-chip>
                </b-col>
              </b-row>

              <b-row
                style="border-bottom: solid 0.1px"
                :key="index"
                v-for="(trDt, index) in tr.Detail"
                :class="trDt.status == 0 ? 'bg-danger' : 'bg-success'"
              >
                <b-col cols="10">
                  <h5>{{ trDt.barcode }}</h5>
                </b-col>
                <b-col>
                  <h5>{{ trDt.quantity }}</h5>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </vs-card>
      </b-col>
      <b-col> </b-col>
    </b-row>
    <vs-popup
      class="holamundo"
      title="Sipariş Tamamla"
      :active.sync="popupOrderList"
      fullscreen
    >
      <b-row>
        <b-col>
          <vs-card>
            <b-row align-h="start">
              <b-col cols="12" md="auto">
                <h5>{{ program }}</h5>
                <vs-divider></vs-divider>
              </b-col>

              <b-col cols="12" md="auto">
                <vs-button
                  :disabled="islemiTamamlaValidate"
                  @click="islemiTamamla()"
                  type="gradient"
                  color="danger"
                  style="border-radius: 5px"
                  id="button-with-loading"
                  >İşlemi Tamamla</vs-button
                >
              </b-col>
            </b-row>
          </vs-card>
          <vs-card>
            <b-row>
              <b-col style="margin-bottom: 8px">
                <b-form-input
                  v-model="barcodeDetailVal"
                  @keyup.enter="barcodeDetail()"
                  placeholder="Barkod Giriniz"
                  id="barkodR"
                />
              </b-col>

              <vs-table :data="orderListDetail">
                <template slot="thead">
                  <vs-th sort-key="barcode">Barkod</vs-th>
                  <vs-th sort-key="stockCode">Stok Kodu</vs-th>
                  <vs-th sort-key="stockName">Stok Adı</vs-th>
                  <vs-th sort-key="quantity">Adet</vs-th>
                  <vs-th sort-key="quantity">Eklenen</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].barcode">
                      {{ data[indextr].barcode }}
                    </vs-td>
                    <vs-td :data="data[indextr].stockCode">
                      {{ data[indextr].stockCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].stockName">
                      {{ data[indextr].stockName }}
                    </vs-td>
                    <vs-td :data="data[indextr].quantity">
                      {{ data[indextr].quantity }}
                    </vs-td>
                    <vs-td :data="data[indextr].added">
                      <vs-chip
                        color="success"
                        v-if="data[indextr].added == data[indextr].quantity"
                      >
                        {{ data[indextr].added }}
                      </vs-chip>
                      <vs-chip color="danger" v-else-if="data[indextr].added == 0">
                        {{ data[indextr].added }}
                      </vs-chip>
                      <vs-chip color="warning" v-else>
                        {{ data[indextr].added }}
                      </vs-chip>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </b-row>
          </vs-card>
        </b-col>
        <b-col cols="4">
          <vs-card>
            <vs-checkbox v-model="isInvoice">Etiket çıktısı alınsın mı?</vs-checkbox>
            <b-row align-v="center" style="margin-top: 8px">
              <b-col cols="5" align-self="center">
                <b-form-group
                  label="Sipariş Numarası: "
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="7">
                <h6 style="margin: 0px">{{ orderNumber }}</h6>
              </b-col>
            </b-row>
            <b-row align-v="center" style="margin-top: 8px">
              <b-col cols="5" align-self="center">
                <b-form-group
                  label="Sipariş Tarihi: "
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="7">
                <h6 style="margin: 0px">{{ siparisTarihi }}</h6>
              </b-col>
            </b-row>

            <b-row align-v="center" style="margin-top: 8px">
              <b-col cols="5" align-self="center">
                <b-form-group
                  label="Kargo Şirketi: "
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="7">
                <h6 style="margin: 0px">{{ cargoProviderName }}</h6>
              </b-col>
            </b-row>
            <b-row align-v="center" style="margin-top: 8px">
              <b-col cols="5" align-self="center">
                <b-form-group
                  label="Kargo Numarası: "
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="7">
                <h6 style="margin: 0px">{{ cargoTrackingNumber }}</h6>
              </b-col>
            </b-row>
            <b-row align-v="center" style="margin-top: 8px">
              <b-col cols="5" align-self="center">
                <b-form-group
                  label="Toplam: "
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="7">
                <h6 style="margin: 0px">
                  {{
                    new Intl.NumberFormat("tr-TR", {
                      style: "currency",
                      currency: "TRY",
                    }).format(parseFloat(amount.toString().replace(",", ".")))
                  }}
                </h6>
              </b-col>
            </b-row>
            <vs-divider></vs-divider>
            <h5>TESLİMAT BİLGİLERİ</h5>
            <b-row align-v="center" style="margin-top: 8px">
              <b-col cols="3" align-self="center">
                <b-form-group
                  label="Ad/Soyad: "
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <h6 style="margin: 0px">{{ shipFullName }}</h6>
              </b-col>
            </b-row>
            <b-row align-v="center" style="margin-top: 8px">
              <b-col cols="3" align-self="center">
                <b-form-group
                  label="Adres: "
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <h6 style="margin: 0px">
                  {{ shipFullAddress }} - {{ shipCity }} / {{ shipDistrict }}
                </h6>
              </b-col>
            </b-row>
            <h5 style="margin-top: 10px">FATURA BİLGİLERİ</h5>
            <b-row align-v="center" style="margin-top: 8px">
              <b-col cols="3" align-self="center">
                <b-form-group
                  label="Ad/Soyad: "
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <h6 style="margin: 0px">{{ invoiceFullName }}</h6>
              </b-col>
            </b-row>
            <b-row align-v="center" style="margin-top: 8px">
              <b-col cols="3" align-self="center">
                <b-form-group
                  label="Adres: "
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <h6 style="margin: 0px">
                  {{ invoiceFullAddress }} - {{ invoiceCity }} / {{ invoiceDistrict }}
                </h6>
              </b-col>
            </b-row>
          </vs-card>
        </b-col>
      </b-row>
      <iframe width="560" height="315" id="ciktiPdf" src="" frameborder="0"></iframe>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Ürün Toplama"
      :active.sync="popupProductList"
      fullscreen
    >
      <b-row>
        <UrunToplama />
      </b-row>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Kullanılan Raf Numarası"
      :active.sync="popupProductShelf"
      @close="clearFields"
      @cancel="clearFields"
    >
      <b-row>
        <h6 class="text-primary" style="font-size: 150px; text-align: center">
          {{ usedShelf }}
        </h6>
      </b-row>
    </vs-popup>
    <vs-popup
      fullscreen
      class="holamundo"
      title="Fatura Tekrar Yazdırma"
      :active.sync="popupFatura"
    >
      <b-row>
        <b-col cols="3">
          <vs-input
            class="inputx"
            placeholder="Arama"
            @keyup.enter="faturaCikti()"
            :ref="faturaBulOrderNumber"
            v-model="faturaBulOrderNumber"
          />
        </b-col>
      </b-row>

      <ag-grid-vue
        style="width: 100%; height: 400px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="listSonFaturalar"
        :localeText="localeText"
        @grid-ready="onGridReady"
        :rowSelection="'single'"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-popup>
  </div>
</template>

<script>
import state from "../../store/state";
import Store from "../../store/store";
import UrunToplama from "./UrunToplama.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import FaturaCiktisiButon from "../components/uzum-components/pazaryeri-components/FaturaCiktisiButon.vue";

export default {
  data() {
    return {
      isInvoice: true,
      localeText: null,

      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      faturaBulOrderNumber: "",
      listSonFaturalar: [],
      usedShelf: "",
      popupProductShelf: false,
      islemiTamamlaValidate: true,
      popupProductList: false,
      barcodeDetailVal: "",
      popupOrderList: false,
      barcode: "",
      urunList: [],
      filteredBarcode: "",
      orderListDetail: [],
      orderList: [],
      program: "",
      shipFullName: "",
      shipFullAddress: "",
      shipCity: "",
      shipDistrict: "",
      siparisTarihi: "",
      quantity: "",
      orderNumber: "",
      invoiceFullName: "",
      invoiceFullAddress: "",
      invoiceDistrict: "",
      invoiceCity: "",
      cargoProviderName: "",
      cargoTrackingNumber: "",
      amount: "",
      popupFatura: false,
    };
  },
  created() {
    this.getStockPackageList();
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
  mounted() {
    document.addEventListener("keyup", this.handleKeyup);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKeyup);
  },

  components: { UrunToplama, AgGridVue, FaturaCiktisiButon },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    faturaCikti() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      var args;
      if (Store.state.sube == "")
        args = {
          token: Store.state.tokenId,
          program: this.pazaryeriVal,
          EMPLOYEEID: Store.state.plasiyer,
          faturaAranan: vm.faturaBulOrderNumber,
        };
      else
        args = {
          token: Store.state.tokenId,
          program: this.pazaryeriVal,
          EMPLOYEEID: Store.state.sube,
          faturaAranan: vm.faturaBulOrderNumber,
        };

      soap.createClient(url, function (err, client) {
        client.sonFaturalar(args, function (err, result) {
          if (result.sonFaturalarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.sonFaturalarResult);
            vm.listSonFaturalar = vm.veriler;

            vm.popupFatura = true;
          }
        });
      });
    },
    clearFields() {
      console.log("clearFields");
      document.getElementById("barkodM").focus();
    },

    handleKeyup(event) {
      if (event.key === "Enter") {
        if (this.popupProductShelf == true) {
          document.getElementById("barkodM").focus();
        } else {
          document.getElementById("barkodM").blur(); // Odaklanmayı kaldırmak için
        }
        this.popupProductShelf = false;
      }
    },
    listeTemizle() {
      this.program = "";
      this.orderNumber = "";
      this.siparisTarihi = "";
      this.cargoProviderName = "";
      this.cargoTrackingNumber = "";
      this.amount = "";
      this.shipFullName = "";
      this.shipFullAddress = "";
      this.shipCity = "";
      this.shipDistrict = "";
      this.invoiceFullName = "";
      this.invoiceFullAddress = "";
      this.invoiceCity = "";
      this.invoiceDistrict = "";
      this.islemiTamamlaValidate = false;
      this.popupProductList = false;
    },
    islemiTamamla() {
      var vm = this;
      vm.islemiTamamlaValidate = true;

      var vs = this.$vs;
      vs.loading({
        container: "#button-with-loading",
        scale: 0.45,
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        orderNumber: vm.orderNumber,
        program: vm.program,
        grupKod: Store.state.grupKod,
        token: Store.state.tokenId,
        recId: 0,
        EMPLOYEEID: Store.state.plasiyer,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.faturaYaz(args, function (err, result) {
          if (result.faturaYazResult == "-1") {
            Store.dispatch("logout");
          } else {
            try {
              vm.veriler = JSON.parse(result.faturaYazResult);
              console.log(vm.veriler);
              if (vm.veriler.response == "Ok") {
                vs.loading.close("#button-with-loading > .con-vs-loading");
                vm.receiptId = vm.veriler.ReceiptId;
                vm.faturaNo = vm.veriler.FaturaNo.replace("'", "");
                vs.loading.close("#button-with-loading-partile > .con-vs-loading");
                vs.notify({
                  title: "Fatura",
                  text: "Fatura İşlemi Başarılı",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                if (vm.isInvoice == true)
                  if (
                    Store.state.printAddress != "" ||
                    typeof Store.state.printAddress != undefined ||
                    Store.state.printAddress != null
                  )
                    document.getElementById("ciktiPdf").src =
                      Store.state.printAddress +
                      vm.faturaNo.replace("'", "") +
                      "&Tr=" +
                      vm.program;
                console.log(
                  (document.getElementById("ciktiPdf").src =
                    Store.state.printAddress +
                    vm.faturaNo.replace("'", "") +
                    "&Tr=" +
                    vm.program)
                );
                //     document.getElementById("barkodR").focus();
                vm.listeTemizle();

                vm.getStockPackageList();
              } else {
                vs.loading.close("#button-with-loading > .con-vs-loading");
                vs.notify({
                  title: "Fatura",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                  fixed: true,
                });
              }
            } catch (error) {
              console.log(error);
              if (error.toString().includes("focus")) {
                vs.loading.close("#button-with-loading > .con-vs-loading");
              } else {
                vs.loading.close("#button-with-loading > .con-vs-loading");
                vs.notify({
                  title: "Fatura",
                  text: "Herhangi bir cevap dönmedi" + error,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                  fixed: true,
                });
              }
            }
          }
        });
      });
    },
    urunListGtr() {
      this.popupProductList = true;
    },

    barcodeDetail() {
      const vs = this.$vs;
      let findedData = this.orderListDetail.find(
        (item) => item.barcode === this.barcodeDetailVal
      );
      console.log(findedData);
      if (findedData) {
        let index = this.orderListDetail.indexOf(findedData);
        if (this.orderListDetail[index].added == 0) {
          this.orderListDetail[index].added = 1;
        } else {
          if (this.orderListDetail[index].quantity <= this.orderListDetail[index].added) {
            vs.notify({
              text: "Okutulan adet sipariş adedinden büyük olamaz.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          } else {
            this.orderListDetail[index].added = this.orderListDetail[index].added + 1;
          }
        }
      } else {
        vs.notify({
          text: "Barkod listede bulunmuyor.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
      let orderTotal = 0,
        addedTotal = 0;
      this.orderListDetail.forEach((val, index) => {
        orderTotal += val.quantity;
        addedTotal += val.added;
      });
      console.log(orderTotal);
      console.log(addedTotal);

      if (orderTotal == addedTotal) this.islemiTamamlaValidate = false;

      this.barcodeDetailVal = "";
      document.getElementById("barkodR").focus();
      console.log(this.orderListDetail);
    },
    getOrderDetails(orderNumber) {
      const vm = this;
      vm.popupOrderList = true;
      vm.islemiTamamlaValidate = true;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        orderNumber: orderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.urunOrderList(args, function (err, result) {
          if (result.urunOrderListResult == "-1") {
            Store.dispatch("logout");
          }
          let veriler2 = JSON.parse(result.urunOrderListResult);

          console.log(veriler2);
          vm.orderList = veriler2;
          vm.orderListDetail = vm.orderList[0].Detail;
          vm.orderListDetail.forEach((val, index) => {
            vm.orderListDetail[index] = {
              barcode: val.barcode,
              stockCode: val.stockCode,
              stockName: val.stockName,
              quantity: val.quantity,
              added: 0,
            };
          });
          console.log(vm.orderListDetail);
          vm.program = vm.orderList[0].program;
          vm.shipFullName = vm.orderList[0].shipFullName;
          vm.shipFullAddress = vm.orderList[0].shipFullAddress;
          vm.shipCity = vm.orderList[0].shipCity;
          vm.shipDistrict = vm.orderList[0].shipDistrict;
          vm.siparisTarihi = vm.orderList[0].siparisTarihi;
          vm.quantity = vm.orderList[0].quantity;
          vm.orderNumber = vm.orderList[0].orderNumber;
          vm.invoiceFullName = vm.orderList[0].invoiceFullName;
          vm.invoiceFullAddress = vm.orderList[0].invoiceFullAddress;
          vm.invoiceDistrict = vm.orderList[0].invoiceDistrict;
          vm.invoiceCity = vm.orderList[0].invoiceCity;
          vm.cargoProviderName = vm.orderList[0].cargoProviderName;
          vm.cargoTrackingNumber = vm.orderList[0].cargoTrackingNumber;
          vm.amount = vm.orderList[0].amount;
          if (vm.program == "Hepsiburada") vm.isInvoice = false;
          else vm.isInvoice = true;
        });
      });
    },
    getStockPackageList() {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.urunPaketlemeList(args, function (err, result) {
          if (result.urunPaketlemeListResult == "-1") {
            Store.dispatch("logout");
          }
          let veriler = JSON.parse(result.urunPaketlemeListResult);
          vm.urunList = veriler;
          vm.urunList.forEach((val, index) => {
            val.Detail.forEach((val2, index2) => {
              if (val2.barcode == vm.barcode) {
                vm.filteredBarcode = val2.barcodeQuantity;
              }
            });
          });
          vm.barcode = "";

          // document.getElementById("barkodM").focus();
        });
      });
    },
    filterOrderList() {
      const vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        barcode: vm.barcode.trim(),
      };
      soap.createClient(url, function (err, client) {
        client.urunPaketleme(args, function (err, result) {
          if (result.urunPaketlemeResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            console.log(JSON.parse(result.urunPaketlemeResult));
            let response = JSON.parse(result.urunPaketlemeResult);
            if (response.response == "No") {
              vs.notify({
                text: response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            } else {
              vm.popupProductShelf = true;
              vm.usedShelf = response.message;
            }
            vm.getStockPackageList();
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Ad Soyad",
        sortable: true,
        filter: "agTextColumnFilter",
        valueGetter: fullNameGetter,
        field: "Column1&invoiceFirstName&shipLastName",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Mağaza Kodu",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "magazaKodu",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },

      {
        width: 100,
        field: "",
        cellRendererFramework: "FaturaCiktisiButon",
        headerName: "Tekrar Yazdır",
      },
      {
        width: 100,
        field: "",
        cellRendererFramework: "EBelgeButon",
        headerName: "E Belge",
      },
    ];
  },
};
function fullNameGetter(params) {
  if (typeof params.data.Column1 == "undefined") {
    params.data.Column1 = "";
  }
  if (typeof params.data.shipFirstName == "undefined") {
    params.data.shipFirstName = "";
  }
  if (typeof params.data.shipLastName == "undefined") {
    params.data.shipLastName = "";
  }
  return (
    params.data.Column1 + " " + params.data.shipFirstName + " " + params.data.shipLastName
  );
}
</script>
